import { NodeSpec } from 'prosemirror-model';

import BulletList from '../BulletList';

export default class InlineEditorBulletList extends BulletList {
  get schema(): NodeSpec {
    return {
      ...this._schema,
      toDOM: () => ['ul', { class: 'list-disc' }, 0],
    };
  }
}
